import React, { useEffect } from "react";
const TermsCondition = () => {
    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
  return (
    <div className="bg-[#e9f6e8] font-lexend text-[#3a683f] ">
      <h1 className="xl:text-6xl lg:text-5xl text-4xl font-lexend pt-36 lg:pb-24 md:pb-16 pb-12 font-light text-center ">
        Terms & Conditions
      </h1>
      <div className="w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[85rem] 2xl:px-0 xl:px-8 md:px-0 px-6  xs:px-4 mx-auto">
        <div className="pb-10 sm:text-sm text-base  flex flex-col gap-5 pe-5 font-light ">
          <p>
            Welcome to <span className="font-semibold">Moondew</span>, a brand
            operated by Livvon Comforts Pvt. Ltd. ("Moondew", "we", "us", or
            "our"). These Terms & Conditions govern your access to and use of
            our website, products, and services available through{" "}
            <span className="font-semibold">Moondew.in</span>.
          </p>
          <p className="">
            By accessing, browsing, or using our website, you agree to be bound
            by these Terms & Conditions. If you do not agree with any part of
            these Terms, please discontinue use of the website immediately.
          </p>
        </div>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Acceptance Of Terms
        </h2>
        <div className="pb-6 sm:text-sm text-base mt-1.5 flex flex-col gap-5  font-light ">
          <p>
            By visiting our website and/or purchasing products from us, you
            engage in our services and agree to be bound by these Terms &
            Conditions, including any policies referenced herein, such as our
            Privacy Policy, Shipping Policy, and Return & Refund Policy.
          </p>
          <p>
            These Terms apply to all users of the website, including customers,
            browsers, merchants, vendors, and contributors of content.
          </p>
        </div>
        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Eligibility
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light">
          You must be at least 18 years of age to use this website or make
          purchases.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p className="mt-1.5 ">
            If you are under 18 years of age, you may use this website only
            under the supervision of a parent or legal guardian who agrees to be
            bound by these Terms.
          </p>
        </div>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Products And Services
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          <span className="font-semibold">Moondew</span> offers products and related services through its website.
        </p>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We strive to ensure that all product descriptions, images, pricing,
          specifications, and other content are accurate. However, we do not
          guarantee that all information is complete, current, accurate, or
          error-free. We reserve the right to:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Modify product descriptions or pricing</li>
            <li>&nbsp;Limit product quantities</li>
            <li>&nbsp;Discontinue products or services</li>
            <li>&nbsp;Restrict sales to certain regions or customers n</li>
            <li>&nbsp;Refuse service to anyone at our discretio</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          Certain products may be available exclusively online and may be
          subject to limited availability.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Pricing And Payments
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          All prices displayed on the website are in Indian Rupees (INR) unless
          otherwise stated.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>
            Applicable taxes, shipping fees, and other charges will be displayed
            during checkout.
          </p>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          Payments must be made through approved payment methods available on
          the website.
        </p>
        <p className="pb-6 sm:text-sm text-base font-light ">
          We reserve the right to correct pricing errors and cancel orders
          placed using incorrect pricing information.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          {" "}
          Order Acceptance And Cancellation
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          Placing an order constitutes an offer to purchase products from{" "}
          <span className="font-semibold">Moondew</span>.
        </p>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We reserve the right to accept, reject, or cancel any order at our
            sole discretion, including but not limited to situations involving:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Product unavailability</li>
            <li>&nbsp;Payment authorization issues</li>
            <li>&nbsp;Pricing or technical errors</li>
            <li>&nbsp;Suspected fraudulent activity</li>
            <li>&nbsp;Violation of these Terms & Conditions</li>
            <li>&nbsp;Incomplete or inaccurate customer information</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          If an order is cancelled after payment has been received, any eligible
          refund will be processed according to our Return & Refund Policy.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          {" "}
          Shipping And Delivery
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We aim to process and dispatch orders within the timelines specified
          on our website.
        </p>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          Delivery timelines are estimates only and may vary due to
          circumstances beyond our control, including:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Courier delays</li>
            <li>&nbsp;Weather conditions</li>
            <li>&nbsp;Public holidays</li>
            <li>&nbsp;Government restrictions</li>
            <li>&nbsp;Natural disasters</li>
            <li>&nbsp;Other unforeseen events</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          <span className="font-semibold">Moondew</span> shall not be liable for
          delays caused by third-party logistics providers.
        </p>
        <p className="pb-6 sm:text-sm text-base font-light ">
          For detailed information, please refer to our Shipping Policy.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Returns, Refunds, And Exchanges
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          Returns, refunds, and exchanges are governed by our Return & Refund
          Policy.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>
            Customers are encouraged to review the policy before making a
            purchase.
          </p>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          <span className="font-semibold">Moondew</span> reserves the right to approve or reject refund and return
          requests in accordance with the conditions outlined in the applicable
          policy.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          User Responsibilities
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          You agree not to:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Use the website for any unlawful purpose</li>
            <li>&nbsp;Violate any applicable laws or regulations</li>
            <li>&nbsp;Interfere with website functionality or security</li>
            <li>
              &nbsp;Attempt unauthorized access to any part of the website
            </li>
            <li>&nbsp;Upload viruses, malware, or harmful code</li>
            <li>&nbsp;Use automated tools to scrape or harvest website data</li>
            <li>&nbsp;Provide false or misleading information</li>
            <li>&nbsp;Engage in fraudulent transactions</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          Violation of these Terms may result in suspension or termination of
          access to the website.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Intellectual Property
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          All content available on this website, including but not limited to:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Logos</li>
            <li>&nbsp;Product images</li>
            <li>&nbsp;Graphics</li>
            <li>&nbsp;Text</li>
            <li>&nbsp;Videos</li>
            <li>&nbsp;Designs</li>
            <li>&nbsp;Trademarks</li>
            <li>&nbsp;Website layout</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base font-light ">
          is the property of <span className="font-semibold">Moondew</span>,
          Livvon Comforts Pvt. Ltd., or its licensors and is protected under
          applicable intellectual property laws.
        </p>
        <p className="pb-6 sm:text-sm text-base font-light ">
          No content may be copied, reproduced, distributed, modified,
          republished, or used without prior written consent.{" "}
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Third-Party Links
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          The website may contain links to third-party websites or services.
        </p>

        <p className="pb-6 sm:text-sm text-base font-light ">
          These links are provided solely for convenience.{" "}
          <span className="font-semibold">Moondew</span> does not control and is
          not responsible for the content, privacy practices, products, or
          services offered by third-party websites.
        </p>
        <p className="pb-6 sm:text-sm text-base font-light ">
          Accessing third-party websites is at your own risk.
        </p>


        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Personal Information
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          Your submission of personal information through our website is governed by our Privacy Policy.
        </p>

        <p className="pb-6 sm:text-sm text-base font-light ">
          By using our website, you acknowledge that you have read and understood our Privacy Policy.
        </p>
        
        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Errors And Inaccuracies
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          Occasionally, information on our website may contain typographical
          errors, inaccuracies, or omissions relating to:{" "}
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Product descriptions</li>
            <li>&nbsp;Pricing</li>
            <li>&nbsp;Promotions</li>
            <li>&nbsp;Shipping information</li>
            <li>&nbsp;Product availability</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          We reserve the right to correct such errors and to modify or update
          information without prior notice, including after an order has been
          submitted.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Prohibited Uses
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          You may not use the website:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;For unlawful activities</li>
            <li>&nbsp;To infringe intellectual property rights</li>
            <li>&nbsp;To harass, abuse, or discriminate against others</li>
            <li>&nbsp;To transmit harmful code or malware</li>
            <li>
              &nbsp;To collect personal information of others without
              authorization
            </li>
            <li>&nbsp;To spam, phish, scrape, crawl, or exploit the website</li>
            <li>&nbsp;To interfere with security features of the website</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          We reserve the right to terminate access for users who violate these
          provisions.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Disclaimer Of Warranties
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          The website, products, and services are provided on an "as is" and "as
          available" basis.
        </p>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          To the fullest extent permitted by law, <span className="font-semibold">Moondew</span> makes no warranties or
          representations regarding:
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Continuous availability of the website</li>
            <li>&nbsp;Accuracy or completeness of information</li>
            <li>&nbsp;Error-free operation</li>
            <li>&nbsp;Compatibility with all devices or systems</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          Use of the website is at your own risk.
        </p>

        <h2 className="xl:text-[23px] capitalize lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          limitation of liability
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          To the fullest extent permitted by applicable law, <span className="font-semibold">Moondew</span>, Livvon
          Comforts Pvt. Ltd., its directors, employees, affiliates, agents,
          contractors, suppliers, and service providers shall not be liable for
          any indirect, incidental, special, punitive, or consequential damages
          arising from:
        </p>

        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Use of or inability to use the website</li>
            <li>&nbsp;Product availability issues</li>
            <li>&nbsp;Service interruptions</li>
            <li>&nbsp;Errors or omissions in website content</li>
            <li>&nbsp;Unauthorized access to user information</li>
          </ul>
        </div>
        <p className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          In any event, our total liability shall not exceed the amount paid by
          you for the relevant product or service giving rise to the claim.
        </p>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Indemnification
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          You agree to indemnify, defend, and hold harmless <span className="font-semibold">Moondew</span>, Livvon
          Comforts Pvt. Ltd., its officers, directors, employees, affiliates,
          partners, contractors, and service providers from any claims, losses,
          damages, liabilities, costs, or expenses arising from:
        </p>

        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <ul className="list-disc ps-6 pt-1">
            <li>&nbsp;Your breach of these Terms</li>
            <li>&nbsp;Your misuse of the website</li>
            <li>&nbsp;Your violation of applicable laws</li>
            <li>&nbsp;Your infringement of any third-party rights</li>
          </ul>
        </div>

        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Termination
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          We reserve the right to suspend, restrict, or terminate your access to
          the website or services at any time, without prior notice, if we
          believe you have violated these Terms & Conditions.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>
            Any obligations or liabilities incurred before termination shall
            survive termination.
          </p>
        </div>
        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Governing Law And Jurisdiction
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          These Terms & Conditions shall be governed by and interpreted in
          accordance with the laws of India.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>
            Any dispute, claim, or controversy arising from or relating to these
            Terms, the website, or any purchase made through the website shall
            be subject to the exclusive jurisdiction of the courts located in
            Hyderabad, Telangana, India.
          </p>
        </div>
        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Changes To These Terms
        </h2>
        <p className="pb-4 sm:text-sm text-base mt-1.5  font-light ">
          <span className="font-semibold">Moondew</span> reserves the right to modify, update, or replace these Terms &
          Conditions at any time.
        </p>
        <div className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          <p>
            Any changes will become effective immediately upon posting on this
            page.
          </p>
        </div>
        <p className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          Your continued use of the website following the publication of changes
          constitutes acceptance of the updated Terms.
        </p>
        <h2 className="xl:text-[23px] lg:text-[20px] md:text-[18px] text-[16px] font-semibold">
          Contact Information
        </h2>
        <p className="pb-6 sm:text-sm text-base mt-1.5  font-light ">
          For any questions, concerns, or requests regarding these Terms &
          Conditions, please contact:
        </p>
        <p className="pb-6 sm:text-sm text-base font-light ">
          <span className="font-semibold">Moondew</span> <br /> SY NO.148 TSIIC,
          Kallakal, Telangana 502336
        </p>
        <p className="pb-6 sm:text-sm text-base font-light ">
          <span className="font-semibold">Email</span> : <a href="mailto:customercare@moondew.in" className="hover:underline">customercare@moondew.in</a>
        </p>
        <div className="w-full h-56 pb-5 flex justify-center items-center  ">
          <span className="bg-[#cfeccd] md:px-10 px-5 py-3 md:text-base text-sm font-light font-lexend text-center">
            By using our Website, you acknowledge that you have read and
            understood this Terms & Conditions and agree to its terms.
          </span>
        </div>
      </div>
    </div>
  );
};

export default TermsCondition;
